import { render, staticRenderFns } from "./MaterialesClaseABC.vue?vue&type=template&id=fc47ecfc&scoped=true&"
import script from "./MaterialesClaseABC.vue?vue&type=script&lang=js&"
export * from "./MaterialesClaseABC.vue?vue&type=script&lang=js&"
import style0 from "./MaterialesClaseABC.vue?vue&type=style&index=0&id=fc47ecfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc47ecfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCard,VCardText,VCardTitle,VCol,VDataTable,VIcon,VRow,VTextField})
